<template>
  <div class="billboard-runtime">
    <div class="search-line">
      <el-input @keyup.enter.native="search" placeholder="请输入关键字" v-model="searchText"></el-input>
      <el-button @click="search" plain size="mini">查询</el-button>
    </div>
    <billboard
      v-if="billboardData && billboardData.length"
      v-loading="loading"
      @search=search
      @edit=edit
      :billboardData="billboardData"
      :billboardProperties="billboardProperties"
      :isRuntime="true"
      :id=id
      ref="billboard">
    </billboard>
    <dialog-form-runtime @goSearch="search" :formRuntimeDialog="formRuntimeDialog"></dialog-form-runtime>
  </div>
</template>

<script>
import billboard from '../design/customPage/billboard'
import DialogFormRuntime from '@/components/shared/dialog-form-runtime.vue'
export default {
  name: 'billboard-runtime',
  props: ['billboardProperties', 'report', 'id'],
  components: {
    billboard,
    DialogFormRuntime
  },
  data () {
    return {
      //  看板信息
      billboardData: [],
      searchText: '',
      classificationColumnId: this.billboardProperties.classificationColumnId || '',
      showColumnId: this.billboardProperties.showColumnId || '',
      loading: true,
      formRuntimeDialog: {
        visible: false,
        id: '',
        width: '',
        dataId: '',
        type: 'form',
        formValidates: [],
        interactions: []
      },
      formId: null
    }
  },
  mounted () {
    //  输入值、当前表的id
    this.search()
    this.$axios.get(`/form-api/defines/findIdByTable?tableId=${this.report.kanBanProperties.showColumnTableId}`)
      .then(res => {
        this.formId = res.data
      })
  },
  methods: {
    search () {
      //  分类列
      let classification = this.report.columns.filter(n => n.expressionText.includes(this.classificationColumnId))[0]
      //  展示列
      let show = this.report.columns.filter(n => n.expressionText.includes(this.showColumnId))[0]
      let seniorFilter = this.searchText ? `${classification.expressionText}includes'${this.searchText}'|${show.expressionText}includes'${this.searchText}'` : ''

      let params = {
        index: 1,
        size: 20,
        filters: {
          seniorFilter: seniorFilter
        }
      }
      this.loading = true
      this.$axios.get(`/report-api/report/data/${this.id}`, {params})
        .then(res => {
          let numberReportColumnId = this.billboardProperties.numberReportColumnId
          res.data.forEach(n => {
            // 给数据添加一个id用于vue渲染
            if (!n.uuid) {
              n.uuid = this.$UUID.create()
            }
            if (n.value.length) {
              let hasSub = []
              let noSub = []
              //  给数据分类。先展示有排序的。再展示未排序的
              n.value.forEach(item => {
                if (item[numberReportColumnId] || item[numberReportColumnId] === 0) {
                  hasSub.push(item)
                } else {
                  noSub.push(item)
                }
              })
              //  根据数字正序排序
              hasSub = hasSub.sort((a, b) => parseInt(a[numberReportColumnId]) - parseInt(b[numberReportColumnId]))
              n.value = [].concat(hasSub, noSub)
              //  重新排序
              let num = 0
              n.value.forEach(item => {
                item[numberReportColumnId] = num
                num++
              })
            }
          })
          this.billboardData = res.data
          this.$refs.billboard.active.columnIndex = ''
          this.$refs.billboard.active.cardIndex = ''
          this.loading = false
        }).catch(() => {
          this.loading = false
        })
    },
    edit (card) {
      this.$set(this.formRuntimeDialog, 'title', '编辑')
      this.formRuntimeDialog.disabled = false
      this.formRuntimeDialog.dataId = card.Id
      this.formRuntimeDialog.type = 'form'
      this.formRuntimeDialog.id = this.formId
      this.$axios.get('/form-api/defines/' + this.formRuntimeDialog.id)
        .then(res => {
          this.$emit('closeFlagChange', false)
          this.formRuntimeDialog.width = JSON.parse(res.data.form.form.properties).formScreen
          this.formRuntimeDialog.visible = true
          this.formRuntimeDialog.formValidates = res.data.form.form.formValidates && res.data.form.form.formValidates.filter(n => n.operationType.includes('update') && n.enable)
          this.formRuntimeDialog.interactions = res.data.form.form.interactions ? res.data.form.form.interactions.filter(n => n.type.includes('update')) : []
        })
    }
  },
  watch: {
    'formRuntimeDialog.visible' (val) {
      if (!val) {
        this.$emit('closeFlagChange', true)
      }
    }
  }
}
</script>

<style lang="scss">
.billboard-runtime{
  padding-top: 10px;
  padding-left: 10px;
  min-width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  height: 100%;
  .search-line{
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    height: 28px;
    .el-input{
      width: 223px;
      margin-right: 10px;
    }
    .el-button{
      color: #52ACF1;
      width: 45px;
      height: 26px;
      border-radius: 5px;
      text-align: center;
      line-height: 26px;
      font-size: 12px;
      padding: 0;
      border: 1px solid #52ACF1;
    }
    .el-button:active{
      color: #419be0;
      border: 1px solid #419be0;
    }
  }
  .billboard{
    height: calc(100% - 43px);
  }
}
</style>
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/report/runtime/billboard-runtime.vue